/**
 * @description Specifies the different screen types and provides some helper functions
 */
export const ScreenType = {
  0: 'Mobile',
  1: 'Tablet',
  2: 'Desktop',
  'Mobile': 0,
  'Tablet': 1,
  'Desktop': 2,

  /**
   * @description Converts a screen state into a ScreenType
   * @param {object} screenState An object which represents a screen state
   * @param {object} availableViews An object with the available views
   * @returns {string} Returns a ScreenType
   */
  getScreenType( screenState, availableViews ) {
    let screenType = ScreenType[2];
    
    if( screenState && screenState.isTablet && availableViews && availableViews.tablet ) {
      screenType = ScreenType[1];
    } else if ( screenState && screenState.isMobile && availableViews && availableViews.mobile ) {
      screenType = ScreenType[0];
    }

    return screenType.toLowerCase();
  }
};